// extracted by mini-css-extract-plugin
export default {"appInstall":"InstallPrompt_appInstall__oELD3"};